module.exports = __webpack_public_path__ + "img/V82.0ed24c11.jpg";